import { motion } from "framer-motion";
import { useEffect, useState } from "react";

export default function StatBlock({ label, value, suffix = "", caption }) {
  const numeric = parseFloat(String(value).replace(/[^\d.]/g, ""));
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!isFinite(numeric)) {
      setDisplay(value);
      return;
    }
    let frame;
    const start = performance.now();
    const duration = 1400;
    const tick = (now) => {
      const t = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - t, 3);
      setDisplay((numeric * eased).toFixed(numeric % 1 ? 1 : 0));
      if (t < 1) frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [numeric, value]);

  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="relative rounded-2xl border border-white/5 bg-zinc-900/40 p-6 md:p-8"
    >
      <div className="absolute top-0 left-6 right-6 h-px bg-gradient-to-r from-transparent via-blue-500/40 to-transparent" />
      <div className="font-mono-accent text-[10px] text-zinc-500">{label}</div>
      <div className="mt-3 flex items-baseline gap-1">
        <span className="font-display text-4xl md:text-5xl font-black tracking-tighter gradient-text">
          {display}
        </span>
        {suffix && (
          <span className="font-display text-2xl md:text-3xl font-black text-amber-400">
            {suffix}
          </span>
        )}
      </div>
      {caption && (
        <div className="mt-2 text-sm text-zinc-400">{caption}</div>
      )}
    </motion.div>
  );
}
